module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-t-mobile-01.5f08f14e.jpg";